module.exports = __webpack_public_path__ + "img/icon_tracing2.76e013d4.svg";